export const downloadAppUris = {
  iOS: {
    PayBy: 'https://apps.apple.com/ae/app/payby/id1513907527',
    BOTIM: 'https://botim.me/home/',
    ToTok: 'https://totok.ai/',
  },
  Android: {
    PayBy: 'https://www.payby.com/android-download',
    BOTIM: 'https://botim.me/home/',
    ToTok: 'https://totok.ai/',
  },
}

export const domainList = {
  localhost: 'sim-m.test2pay.com',
  'sim-activities.test2pay.com': 'sim-m.test2pay.com',
  'uat-activities.test2pay.com': 'uat-m.test2pay.com',
  'activities.payby.com': 'm.payby.com'
}

export const socialPlatforms = [
  {
    name: 'Facebook',
    img: require('public/images/facebook.png'),
    link: 'https://www.facebook.com/PayByOfficial'
  },
  {
    name: 'Twitter',
    img: require('public/images/twitter.png'),
    link: 'https://twitter.com/PayByOfficial'
  },
  {
    name: 'linkedin',
    img: require('public/images/linkedin.png'),
    link: 'https://www.linkedin.com/company/payby'
  },
  {
    name: 'Instagram',
    img: require('public/images/Instagram.png'),
    link: 'https://www.instagram.com/PayByOfficial'
  },
  {
    name: 'YouTube',
    img: require('public/images/youtube.png'),
    link:
      'https://www.youtube.com/channel/UCKfEg8ILgEo7DOLZhmVilmA/featured?view_as=subscriber'
  }
]

export const botimSocialPlatforms = [
  {
    name: 'Facebook',
    img: require('public/images/facebook.png'),
    link: 'https://www.facebook.com/TheBOTIM/'
  },
  {
    name: 'Twitter',
    img: require('public/images/twitter.png'),
    link: ' https://twitter.com/botimvideocall'
  },
  {
    name: 'Instagram',
    img: require('public/images/Instagram.png'),
    link: 'https://instagram.com/botim_ae?igshid=YmMyMTA2M2Y='
  }
]
